<template>
  <div
    class="d-flex flex-column align-items-center m-0 p-0 w-100 h-100 overflow-hidden position-relative"
  >
    <div
      ref="diamondContainer"
      class="pe-none"
      style="
        position: fixed;
        z-index: 10000;
        pointer-events: none;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      "
    ></div>
    <div
      ref="mainContainer"
      class="col-12 col-md-10 d-flex flex-column position-relative h-100 overflow-x-hidden"
    >
      <div class="d-flex">
        <div class="d-none d-md-block my-width-20"></div>
        <div
          class="text-center text-md-start d-flex flex-column justify-content-center py-3 my-title-content"
        >
          <div>
            <h1 class="mb-0 my-text-lg my-color-light-gray">
              {{ selectedName ? `${selectedName}的光譜` : '政治人物的光譜' }}
            </h1>
          </div>
        </div>
        <div class="d-none d-md-block my-side-section my-width-20"></div>
      </div>

      <div
        ref="contentContainer"
        class="d-flex position-relative min-w-0 min-h-0 overflow-hidden my-flex-1-1-0"
      >
        <div ref="leftSection" class="my-side-section position-relative z-1 my-width-20">
          <div
            class="d-flex flex-column gap-2 align-items-end justify-content-center position-absolute top-0 start-0 end-0 bottom-0 pe-2 ps-0"
          >
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="goHome"
              type="button"
            >
              <div
                class="d-flex align-items-center justify-content-center rounded-circle mt-2 my-size-32 my-border-dark-gray"
              >
                <i class="fas fa-arrow-left"></i>
              </div>
              <span class="mt-2">返回首頁</span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleDataPoints"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showDataPoints" class="fa-solid fa-check me-1"></i
                >{{ showDataPoints ? '隱藏黑點' : '顯示黑點' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleCrosshairPoints"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showCrosshairPoints" class="fa-solid fa-check me-1"></i
                >{{ showCrosshairPoints ? '隱藏十字點' : '顯示十字點' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleSDE"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showSDE" class="fa-solid fa-check me-1"></i
                >{{ showSDE ? '隱藏橢圓' : '顯示橢圓' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleDirectionGrid"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showDirectionGrid" class="fa-solid fa-check me-1"></i
                >{{ showDirectionGrid ? '隱藏方向' : '顯示方向' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleScaledGrid"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showScaledGrid" class="fa-solid fa-check me-1"></i
                >{{ showScaledGrid ? '隱藏網格縮放' : '顯示網格縮放' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleDelaunayFill"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showDelaunayFill" class="fa-solid fa-check me-1"></i
                >{{ showDelaunayFill ? '隱藏三角' : '顯示三角' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleCircleGrid"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showCircleGrid" class="fa-solid fa-check me-1"></i
                >{{ showCircleGrid ? '隱藏圓網格' : '顯示圓網格' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleColorGrid"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showColorGrid" class="fa-solid fa-check me-1"></i
                >{{ showColorGrid ? '隱藏數值網格' : '顯示數值網格' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleQuadtree"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showQuadtree" class="fa-solid fa-check me-1"></i
                >{{ showQuadtree ? '隱藏四元樹' : '顯示四元樹' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleStraightGrid"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showStraightGrid" class="fa-solid fa-check me-1"></i
                >{{ showStraightGrid ? '隱藏直線網格' : '顯示直線網格' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleBarChart"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showBarChart" class="fa-solid fa-check me-1"></i
                >{{ showBarChart ? '隱藏長條圖' : '顯示長條圖' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleLineChart"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showLineChart" class="fa-solid fa-check me-1"></i
                >{{ showLineChart ? '隱藏折線圖' : '顯示折線圖' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleGradient"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showGradient" class="fa-solid fa-check me-1"></i
                >{{ showGradient ? '隱藏漸層' : '顯示漸層' }}
              </span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1 d-flex flex-column align-items-center"
              style="min-width: 100px"
              @click="toggleDarkGrayLayer"
              type="button"
            >
              <span style="text-align: center">
                <i v-if="showDarkGrayLayer" class="fa-solid fa-check me-1"></i
                >{{ showDarkGrayLayer ? '隱藏深灰層' : '顯示深灰層' }}
              </span>
            </button>
          </div>
        </div>

        <div
          ref="centerSection"
          class="flex-grow-1 my-flex-grow-1 position-relative min-w-0 min-h-0 overflow-hidden my-flex-1-1-0"
        ></div>

        <div ref="rightSection" class="my-side-section position-relative z-3 my-width-20">
          <div
            class="left-section d-flex flex-column align-items-start justify-content-center position-absolute top-0 start-0 end-0 bottom-0 ps-2 pe-0 overflow-y-auto gap-4"
          >
            <button
              v-for="name in POLITICIAN_NAMES"
              :key="name"
              class="btn my-button my-text-sm rounded px-2 py-1"
              :class="{ active: selectedName === name }"
              @click="handleNameClick(name)"
              type="button"
            >
              {{ name }}
            </button>
          </div>
        </div>

        <div
          ref="svgContainer"
          class="position-absolute top-0 start-0 end-0 bottom-0 z-2 pe-none"
        ></div>

        <div
          ref="boxesContainer"
          class="position-absolute top-0 start-0 end-0 bottom-0 z-3 pe-none"
        ></div>
      </div>

      <div class="d-flex">
        <div class="d-none d-md-block my-width-20"></div>
        <div
          class="d-flex justify-content-between align-items-center py-2 px-2 px-md-0 my-footer-content"
        >
          <div class="d-flex align-items-center gap-3">
            <span class="my-text-sm my-text-dark-gray">共有 {{ totalDataPoints }} 個點</span>
          </div>

          <div class="d-flex align-items-center gap-2">
            <button
              class="btn my-button my-text-sm rounded px-2 py-1"
              @click="downloadData"
              type="button"
            >
              <span style="text-align: center">下載資料</span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1"
              @click="downloadImage"
              type="button"
            >
              <span style="text-align: center">下載圖片</span>
            </button>
            <button
              class="btn my-button my-text-sm rounded px-2 py-1"
              @click="downloadPDF"
              type="button"
            >
              <span style="text-align: center">下載PDF</span>
            </button>
            <div class="my-text-sm my-text-dark-gray">szfftz</div>
          </div>
        </div>
        <div class="d-none d-md-block my-width-20"></div>
      </div>
    </div>

    <div v-if="loading" class="my-loading-overlay text-center my-text-dark-gray">
      <div class="spinner-border mb-3 my-spinner-lg" role="status">
        <span class="visually-hidden">載入中...</span>
      </div>
      <p class="mt-3 mb-0 my-text-sm my-text-dark-gray">正在載入數據...</p>
    </div>

    <div v-if="error" class="my-error-overlay text-center p-5 rounded my-text-dark-gray">
      <div class="alert alert-danger mb-0" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i><strong>錯誤：</strong>{{ error }}
      </div>
    </div>

    <div
      ref="tooltip"
      class="my-tooltip position-fixed bg-dark text-white px-2 py-1 rounded"
      style="
        pointer-events: none;
        z-index: 10001;
        opacity: 0;
        transition: opacity 0.2s;
        font-size: 12px;
      "
    >
      0 個點
    </div>

    <div
      class="position-fixed"
      style="
        bottom: 20px;
        right: 20px;
        background-color: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 15px;
        border-radius: 8px;
        z-index: 1000;
        font-size: 12px;
        max-width: 400px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
      "
    >
      <div class="mb-2">
        <div class="d-flex align-items-center mb-1">
          <i
            class="fa-solid fa-diamond me-1"
            style="color: var(--my-color-yellow); font-size: 0.875rem"
          ></i>
          <span>平均 {{ meanCenterText }}</span>
          <span
            class="ms-2 d-inline-block"
            :style="{
              width: '12px',
              height: '12px',
              backgroundColor: meanCenterColor,
              border: '1px solid rgba(255,255,255,0.3)',
            }"
          ></span>
          <span v-if="meanCenterHex" class="ms-1">{{ meanCenterHex }}</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <i
            class="fa-solid fa-diamond me-1"
            style="color: var(--my-color-red); font-size: 0.875rem"
          ></i>
          <span>中位數 {{ medianCenterText }}</span>
          <span
            class="ms-2 d-inline-block"
            :style="{
              width: '12px',
              height: '12px',
              backgroundColor: medianCenterColor,
              border: '1px solid rgba(255,255,255,0.3)',
            }"
          ></span>
          <span v-if="medianCenterHex" class="ms-1">{{ medianCenterHex }}</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <i
            class="fa-solid fa-diamond me-1"
            style="color: var(--my-color-green); font-size: 0.875rem"
          ></i>
          <span>中心 {{ centralFeatureText }}</span>
          <span
            class="ms-2 d-inline-block"
            :style="{
              width: '12px',
              height: '12px',
              backgroundColor: centralFeatureColor,
              border: '1px solid rgba(255,255,255,0.3)',
            }"
          ></span>
          <span v-if="centralFeatureHex" class="ms-1">{{ centralFeatureHex }}</span>
        </div>
      </div>
      <div class="border-top pt-2" style="border-color: rgba(255, 255, 255, 0.2) !important">
        <div class="mb-1">Lines: {{ averageDirection }}</div>
        <div class="mb-1">Grids: {{ averageScaledGridSize }}</div>
        <div class="mb-1">Triangles: {{ averageTriangleArea }}</div>
        <div class="mb-1">Circles: {{ averageCircleSize }}</div>
        <div>Mean Points: {{ averageColorGrid.toFixed(2) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, shallowRef, computed, markRaw, onMounted, onBeforeUnmount, onUnmounted } from 'vue';
  import { useRouter } from 'vue-router';
  import * as d3 from 'd3';
  import { Delaunay } from 'd3-delaunay';
  import { jsPDF } from 'jspdf';
  import 'svg2pdf.js';
  import { POLITICIAN_NAMES } from '../config/constants.js';
  import { getCSSVariable, createGradientSpectrum } from '../utils/utils.js';

  export default {
    name: 'VizView',
    setup() {
      const router = useRouter();
      const mainContainer = ref(null);
      const contentContainer = ref(null);
      const svgContainer = ref(null);
      const boxesContainer = ref(null);
      const diamondContainer = ref(null);
      const leftSection = ref(null);
      const centerSection = ref(null);
      const rightSection = ref(null);
      const rightSectionWidth = ref(0);
      const tooltip = ref(null);
      const showColorGrid = ref(false);
      const showDirectionGrid = ref(false);
      const showCircleGrid = ref(false);
      const showQuadtree = ref(false);
      const showScaledGrid = ref(false);
      const showStraightGrid = ref(false);
      const showBottomLineGrid = ref(false);
      const showBarChart = ref(false);
      const showLineChart = ref(false);
      const showGradient = ref(false);
      const showDarkGrayLayer = ref(false);
      const showDarkGrid = ref(false);
      const showDataPoints = ref(false);
      const showCrosshairPoints = ref(false);
      const showDelaunayFill = ref(false);
      const showSDE = ref(false);
      const showDBSCAN = ref(false);
      const averageTriangleArea = ref(0);
      const medianTriangleArea = ref(0);
      const nearestNeighborRatio = ref(0);
      const averageScaledGridSize = ref(0);
      const averageCircleSize = ref(0);
      const averageColorGrid = ref(0);
      const averageDirection = ref(0);
      const meanCenter = shallowRef({ x: 0, y: 0 });
      const medianCenter = shallowRef({ x: 0, y: 0 });
      const centralFeature = shallowRef({ x: 0, y: 0 });
      let svg = null;
      let drawVersion = 0;
      let colorGridGroup = null;
      let directionGridGroup = null;
      let circleGridGroup = null;
      let quadtreeGroup = null;
      let scaledGridGroup = null;
      let straightGridGroup = null;
      let bottomLineGridGroup = null;
      let barChartGroup = null;
      let lineChartGroup = null;
      let gradientGroup = null;
      let darkGrayLayerGroup = null;
      let pointsGroup = null;
      let crosshairGroup = null;
      let delaunayFillGroup = null;
      let sdeGroup = null;
      let resizeTimer = null;
      const pendingTimeouts = [];
      const isMounted = ref(false);
      const loading = ref(false);
      const error = ref(null);
      const allDataPoints = ref([]);
      const totalDataPoints = ref(0);
      const selectedName = ref(null);
      const cookieDataPoints = ref([]);

      const colors = markRaw({
        blue: getCSSVariable('--my-color-blue'),
        green: getCSSVariable('--my-color-green'),
        red: getCSSVariable('--my-color-red'),
        white: getCSSVariable('--my-color-white'),
        yellow: getCSSVariable('--my-color-yellow'),
        dataPoint: getCSSVariable('--my-color-data-point'),
        backgroundGray: getCSSVariable('--my-color-background-gray'),
        darkGray: getCSSVariable('--my-color-dark-gray'),
      });

      const cookieUtils = {
        get(name) {
          const nameEQ = name + '=';
          const cookies = document.cookie.split(';');
          for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) === 0) {
              return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
            }
          }
          return null;
        },
      };

      const loadCookieData = () => {
        const cookiePointsMap = new Map();

        let positionsMap = null;
        const savedPositionsJSON = cookieUtils.get('political-spectrum_positions');
        if (savedPositionsJSON) {
          try {
            const parsed = JSON.parse(savedPositionsJSON);
            if (parsed && typeof parsed === 'object') {
              positionsMap = parsed;
            }
          } catch (e) {
            positionsMap = null;
          }
        }

        POLITICIAN_NAMES.forEach((name) => {
          const fromJson = positionsMap?.[name];
          const xPercent =
            fromJson?.x !== undefined && fromJson?.x !== null
              ? String(fromJson.x)
              : cookieUtils.get(`political-spectrum_${name}_x`);
          const yPercent =
            fromJson?.y !== undefined && fromJson?.y !== null
              ? String(fromJson.y)
              : cookieUtils.get(`political-spectrum_${name}_y`);

          if (
            xPercent !== null &&
            yPercent !== null &&
            xPercent !== '-1' &&
            yPercent !== '-1' &&
            xPercent !== undefined &&
            yPercent !== undefined
          ) {
            cookiePointsMap.set(name, {
              name: name,
              x: parseFloat(xPercent),
              y: parseFloat(yPercent),
            });
          }
        });

        cookieDataPoints.value = Array.from(cookiePointsMap.values());
      };

      const calculateSideSectionWidth = (containerWidth) => {
        if (!containerWidth || containerWidth <= 0) return 0;
        return containerWidth * 0.2;
      };

      const calculateGradientArea = (containerWidth, containerHeight, titleAreaHeight = 0) => {
        const firstSectionWidth = calculateSideSectionWidth(containerWidth);
        const rightWidth = calculateSideSectionWidth(containerWidth);
        const gradientAreaWidth = containerWidth - firstSectionWidth - rightWidth;
        const gradientAreaHeight = containerHeight - titleAreaHeight;
        const gradientAreaLeft = firstSectionWidth;
        const gradientAreaTop = titleAreaHeight;
        return {
          firstSectionWidth,
          rightWidth,
          gradientAreaWidth,
          gradientAreaHeight,
          gradientAreaLeft,
          gradientAreaTop,
        };
      };

      const getInterpolatedColorAtPosition = (xPercent, yPercent) => {
        const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
        const lerp = (start, end, t) => start + (end - start) * t;
        const parseColor = (color) => {
          const parsed = d3.color(color);
          if (!parsed) return { r: 0, g: 0, b: 0 };
          const rgb = parsed.rgb();
          return { r: rgb.r, g: rgb.g, b: rgb.b };
        };

        const x = clamp(xPercent, 0, 1);
        const y = clamp(yPercent, 0, 1);

        const topLeft = parseColor(colors.blue || 'hsl(210, 85%, 65%)');
        const topRight = parseColor(colors.red || 'hsl(0, 85%, 65%)');
        const bottomLeft = parseColor(colors.green || 'hsl(150, 85%, 65%)');
        const bottomRight = parseColor(colors.white || 'hsl(210, 60%, 92%)');

        const top = {
          r: lerp(topLeft.r, topRight.r, x),
          g: lerp(topLeft.g, topRight.g, x),
          b: lerp(topLeft.b, topRight.b, x),
        };
        const bottom = {
          r: lerp(bottomLeft.r, bottomRight.r, x),
          g: lerp(bottomLeft.g, bottomRight.g, x),
          b: lerp(bottomLeft.b, bottomRight.b, x),
        };

        const r = Math.round(lerp(top.r, bottom.r, y));
        const g = Math.round(lerp(top.g, bottom.g, y));
        const b = Math.round(lerp(top.b, bottom.b, y));

        return `rgb(${r}, ${g}, ${b})`;
      };

      const safeSetTimeout = (callback, delay) => {
        const timeoutId = setTimeout(() => {
          if (isMounted.value) {
            callback();
          }
        }, delay);
        pendingTimeouts.push(timeoutId);
        return timeoutId;
      };

      const createGradientSampler = async (width, height) => {
        const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svgElement.setAttribute('width', width);
        svgElement.setAttribute('height', height);

        const d3Svg = d3.select(svgElement);
        createGradientSpectrum({
          svg: d3Svg,
          colors,
          gradientAreaLeft: 0,
          gradientAreaTop: 0,
          gradientAreaWidth: width,
          gradientAreaHeight: height,
        });

        const svgData = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
              URL.revokeObjectURL(url);
              reject(new Error('Canvas context unavailable'));
              return;
            }
            ctx.drawImage(img, 0, 0, width, height);
            URL.revokeObjectURL(url);
            const imageData = ctx.getImageData(0, 0, width, height).data;
            const sampler = (x, y) => {
              const clampedX = Math.max(0, Math.min(width - 1, Math.round(x)));
              const clampedY = Math.max(0, Math.min(height - 1, Math.round(y)));
              const index = (clampedY * width + clampedX) * 4;
              return `rgb(${imageData[index]}, ${imageData[index + 1]}, ${imageData[index + 2]})`;
            };
            resolve(sampler);
          };
          img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error('Failed to render gradient'));
          };
          img.src = url;
        });
      };

      const rgbToHex = (rgbString) => {
        if (!rgbString || rgbString === 'transparent') {
          return '';
        }
        const match = rgbString.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
        if (!match) {
          return '';
        }
        const r = parseInt(match[1], 10);
        const g = parseInt(match[2], 10);
        const b = parseInt(match[3], 10);
        const toHex = (n) => {
          const hex = n.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        };
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
      };

      const loadData = async (name = null) => {
        if (!isMounted.value) return;

        allDataPoints.value = [];
        if (svgContainer.value) {
          d3.select(svgContainer.value).selectAll('svg').remove();
        }

        try {
          // 動態獲取 base path，與 router 邏輯一致
          const getBasePath = () => {
            if (typeof window !== 'undefined') {
              if (
                window.location.hostname.includes('netlify.app') ||
                window.location.hostname.includes('netlify.com')
              ) {
                return '/';
              }
              if (
                window.location.hostname.includes('github.io') ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'
              ) {
                return '/political-spectrum/';
              }
            }
            return '/political-spectrum/';
          };
          
          const basePath = getBasePath();
          const dataPath = `${basePath}data/data_150.json`.replace(/\/+/g, '/'); // 移除重複的斜線
          const response = await fetch(dataPath);
          if (!response.ok) {
            throw new Error(`無法讀取 data/data_150.json: ${response.status} ${response.statusText}`);
          }

          const jsonData = await response.json();
          let resultData = jsonData;

          if (name) {
            resultData = jsonData.filter((item) => item.name === name);
          }

          if (!resultData || resultData.length === 0) {
            if (!isMounted.value) return;
            allDataPoints.value = [];
            totalDataPoints.value = 0;
            loading.value = false;
            loadCookieData();
            safeSetTimeout(() => {
              if (isMounted.value) {
                drawVisualization();
              }
            }, 100);
            return;
          }

          const validPoints = resultData.filter((item) => {
            const x = parseFloat(item.x);
            const y = parseFloat(item.y);

            return (
              x !== -1 &&
              y !== -1 &&
              item.x !== null &&
              item.y !== null &&
              item.x !== undefined &&
              item.y !== undefined &&
              !isNaN(x) &&
              !isNaN(y)
            );
          });

          if (!isMounted.value) return;

          allDataPoints.value = validPoints;
          totalDataPoints.value = resultData.length;

          loading.value = false;
          loadCookieData();
          safeSetTimeout(() => {
            if (isMounted.value) {
              drawVisualization();
            }
          }, 100);
        } catch (err) {
          if (!isMounted.value) return;
          error.value = err.message || '無法讀取 data/data_150.json 檔案';
          allDataPoints.value = [];
          totalDataPoints.value = 0;
          loading.value = false;
          loadCookieData();
          safeSetTimeout(() => {
            if (isMounted.value) {
              drawVisualization();
            }
          }, 100);
        }
      };

      const handleNameClick = (name) => {
        if (!isMounted.value) return;

        if (selectedName.value === name) {
          selectedName.value = null;

          allDataPoints.value = [];
          totalDataPoints.value = 0;
          loading.value = false;

          if (svgContainer.value) {
            d3.select(svgContainer.value).selectAll('svg').remove();
          }

          loadCookieData();

          safeSetTimeout(() => {
            if (isMounted.value) {
              drawVisualization();
            }
          }, 100);
        } else {
          selectedName.value = name;
          loading.value = true;
          loadData(selectedName.value);
        }
      };

      const drawVisualization = () => {
        if (!isMounted.value || !svgContainer.value || !contentContainer.value) return;

        drawVersion += 1;
        const currentDrawVersion = drawVersion;

        d3.select(svgContainer.value).selectAll('svg').remove();
        colorGridGroup = null;
        directionGridGroup = null;
        circleGridGroup = null;
        quadtreeGroup = null;
        scaledGridGroup = null;
        straightGridGroup = null;
        barChartGroup = null;
        lineChartGroup = null;
        delaunayFillGroup = null;
        gradientGroup = null;
        darkGrayLayerGroup = null;
        pointsGroup = null;
        crosshairGroup = null;
        sdeGroup = null;

        const containerRect = contentContainer.value.getBoundingClientRect();
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;

        const titleAreaHeight = 0;
        const {
          rightWidth,
          gradientAreaWidth,
          gradientAreaHeight,
          gradientAreaLeft,
          gradientAreaTop,
        } = calculateGradientArea(containerWidth, containerHeight, titleAreaHeight);
        rightSectionWidth.value = rightWidth;

        svg = d3
          .select(svgContainer.value)
          .append('svg')
          .attr('width', containerWidth)
          .attr('height', containerHeight)
          .attr('class', 'd-block position-relative w-100 h-100')
          .style('pointer-events', 'none');

        darkGrayLayerGroup = svg.append('g').attr('class', 'dark-gray-layer');
        darkGrayLayerGroup
          .append('rect')
          .attr('x', gradientAreaLeft)
          .attr('y', gradientAreaTop)
          .attr('width', gradientAreaWidth)
          .attr('height', gradientAreaHeight)
          .attr('fill', colors.yellow || 'hsl(60, 98%, 63%)');
        darkGrayLayerGroup.style('display', showDarkGrayLayer.value ? 'none' : 'block');

        gradientGroup = createGradientSpectrum({
          svg,
          colors,
          gradientAreaLeft,
          gradientAreaTop,
          gradientAreaWidth,
          gradientAreaHeight,
        });
        if (gradientGroup) {
          gradientGroup.style('display', showGradient.value ? 'block' : 'none');
        }

        const colorGridColumns = 10;
        const colorGridRows = 10;
        const colorGridCellWidth = gradientAreaWidth / colorGridColumns;
        const colorGridCellHeight = gradientAreaHeight / colorGridRows;

        const gridColumns = 20;
        const gridRows = 20;
        const cellWidth = gradientAreaWidth / gridColumns;
        const cellHeight = gradientAreaHeight / gridRows;

        const colorGridCellPointCounts = new Map();
        if (allDataPoints.value.length > 0) {
          allDataPoints.value.forEach((item) => {
            const xPercent = parseFloat(item.x);
            const yPercent = parseFloat(item.y);

            const x = gradientAreaLeft + (xPercent / 100) * gradientAreaWidth;
            const y = gradientAreaTop + (yPercent / 100) * gradientAreaHeight;

            let col = Math.floor((x - gradientAreaLeft) / colorGridCellWidth);
            let row = Math.floor((y - gradientAreaTop) / colorGridCellHeight);

            col = Math.max(0, Math.min(col, colorGridColumns - 1));
            row = Math.max(0, Math.min(row, colorGridRows - 1));

            const cellKey = `${col},${row}`;
            colorGridCellPointCounts.set(cellKey, (colorGridCellPointCounts.get(cellKey) || 0) + 1);
          });
        }

        const cellPointCounts = new Map();
        if (allDataPoints.value.length > 0) {
          allDataPoints.value.forEach((item) => {
            const xPercent = parseFloat(item.x);
            const yPercent = parseFloat(item.y);

            const x = gradientAreaLeft + (xPercent / 100) * gradientAreaWidth;
            const y = gradientAreaTop + (yPercent / 100) * gradientAreaHeight;

            let col = Math.floor((x - gradientAreaLeft) / cellWidth);
            let row = Math.floor((y - gradientAreaTop) / cellHeight);

            col = Math.max(0, Math.min(col, gridColumns - 1));
            row = Math.max(0, Math.min(row, gridRows - 1));

            const cellKey = `${col},${row}`;
            cellPointCounts.set(cellKey, (cellPointCounts.get(cellKey) || 0) + 1);
          });
        }

        let maxCount = 0;
        cellPointCounts.forEach((count) => {
          if (count > maxCount) {
            maxCount = count;
          }
        });

        colorGridGroup = svg
          .append('g')
          .attr('class', 'color-grid-cells')
          .style('pointer-events', 'all')
          .style('display', showColorGrid.value ? 'block' : 'none');

        const colorGridValues = [];
        for (let row = 0; row < colorGridRows; row++) {
          for (let col = 0; col < colorGridColumns; col++) {
            const cellKey = `${col},${row}`;
            const pointCount = colorGridCellPointCounts.get(cellKey) || 0;

            if (pointCount === 0) {
              continue;
            }

            colorGridValues.push(pointCount);

            const x = gradientAreaLeft + col * colorGridCellWidth;
            const y = gradientAreaTop + row * colorGridCellHeight;
            const centerXPercent = (col + 0.5) / colorGridColumns;
            const centerYPercent = (row + 0.5) / colorGridRows;
            const gradientColor = getInterpolatedColorAtPosition(centerXPercent, centerYPercent);

            colorGridGroup
              .append('rect')
              .attr('x', x)
              .attr('y', y)
              .attr('width', colorGridCellWidth)
              .attr('height', colorGridCellHeight)
              .attr('fill', gradientColor)
              .attr('stroke', 'none')
              .on('mouseover', function (event) {
                if (tooltip.value) {
                  const tooltipElement = tooltip.value;
                  tooltipElement.textContent = gradientColor;
                  tooltipElement.style.opacity = '1';
                  tooltipElement.style.left = `${event.pageX + 10}px`;
                  tooltipElement.style.top = `${event.pageY + 10}px`;
                }
              })
              .on('mouseout', function () {
                if (tooltip.value) {
                  tooltip.value.style.opacity = '0';
                }
              });

            colorGridGroup
              .append('text')
              .attr('x', x + colorGridCellWidth / 2)
              .attr('y', y + colorGridCellHeight / 2)
              .attr('text-anchor', 'middle')
              .attr('dominant-baseline', 'middle')
              .attr('font-size', Math.min(colorGridCellWidth, colorGridCellHeight) * 0.3 + 'px')
              .attr('font-weight', 'bold')
              .attr('fill', colors.darkGray)
              .text(pointCount);
          }
        }

        // Mean Points = 有數值的網格 cell 的平均點數
        if (colorGridValues.length > 0) {
          const sum = colorGridValues.reduce((a, b) => a + b, 0);
          averageColorGrid.value = sum / colorGridValues.length;
        } else {
          averageColorGrid.value = 0;
        }

        if (allDataPoints.value.length > 0) {
          const points = allDataPoints.value.map((item) => {
            const xPercent = parseFloat(item.x);
            const yPercent = parseFloat(item.y);

            const x = gradientAreaLeft + (xPercent / 100) * gradientAreaWidth;
            const y = gradientAreaTop + (yPercent / 100) * gradientAreaHeight;

            return {
              name: item.name,
              x: x,
              y: y,
              xPercent: xPercent,
              yPercent: yPercent,
            };
          });

          pointsGroup = svg.append('g').attr('class', 'data-points');
          if (pointsGroup) {
            pointsGroup.style('display', showDataPoints.value ? 'block' : 'none');
          }
          points.forEach((point) => {
            pointsGroup
              .append('circle')
              .attr('cx', point.x)
              .attr('cy', point.y)
              .attr('r', 2)
              .attr('fill', colors.darkGray)
              .attr('opacity', 0.5);
          });

          crosshairGroup = svg.append('g').attr('class', 'crosshair-points');
          if (crosshairGroup) {
            crosshairGroup.style('display', showCrosshairPoints.value ? 'block' : 'none');
          }

          const drawCrosshair = async () => {
            if (!crosshairGroup) return;
            const samplerWidth = Math.max(1, Math.round(gradientAreaWidth));
            const samplerHeight = Math.max(1, Math.round(gradientAreaHeight));
            let sampler = null;

            try {
              sampler = await createGradientSampler(samplerWidth, samplerHeight);
            } catch (err) {
              sampler = null;
            }

            if (!isMounted.value || currentDrawVersion !== drawVersion || !crosshairGroup) {
              return;
            }

            points.forEach((point) => {
              const centerXPercent = (point.x - gradientAreaLeft) / gradientAreaWidth;
              const centerYPercent = (point.y - gradientAreaTop) / gradientAreaHeight;

              const crosshairColor = sampler
                ? sampler(centerXPercent * (samplerWidth - 1), centerYPercent * (samplerHeight - 1))
                : getInterpolatedColorAtPosition(centerXPercent, centerYPercent);

              const crosshairSize = 5;
              crosshairGroup
                .append('line')
                .attr('x1', point.x - crosshairSize)
                .attr('y1', point.y)
                .attr('x2', point.x + crosshairSize)
                .attr('y2', point.y)
                .attr('stroke', crosshairColor)
                .attr('stroke-width', '3pt')
                .attr('opacity', 1.0);
              crosshairGroup
                .append('line')
                .attr('x1', point.x)
                .attr('y1', point.y - crosshairSize)
                .attr('x2', point.x)
                .attr('y2', point.y + crosshairSize)
                .attr('stroke', crosshairColor)
                .attr('stroke-width', '3pt')
                .attr('opacity', 1.0);
            });
          };

          drawCrosshair();

          if (points.length >= 2) {
            const meanX = points.reduce((sum, p) => sum + p.x, 0) / points.length;
            const meanY = points.reduce((sum, p) => sum + p.y, 0) / points.length;

            let covXX = 0;
            let covYY = 0;
            let covXY = 0;

            points.forEach((p) => {
              const dx = p.x - meanX;
              const dy = p.y - meanY;
              covXX += dx * dx;
              covYY += dy * dy;
              covXY += dx * dy;
            });

            const n = points.length;
            covXX /= n - 1;
            covYY /= n - 1;
            covXY /= n - 1;

            const trace = covXX + covYY;
            const det = covXX * covYY - covXY * covXY;
            const discriminant = trace * trace - 4 * det;

            if (discriminant >= 0) {
              const sqrtDisc = Math.sqrt(discriminant);
              const lambda1 = (trace + sqrtDisc) / 2;
              const lambda2 = (trace - sqrtDisc) / 2;

              let v1X, v1Y;
              if (Math.abs(covXY) < 1e-10) {
                v1X = covXX > covYY ? 1 : 0;
                v1Y = covXX > covYY ? 0 : 1;
              } else {
                v1X = 1;
                v1Y = (lambda1 - covXX) / covXY;
                const len = Math.sqrt(v1X * v1X + v1Y * v1Y);
                v1X /= len;
                v1Y /= len;
              }

              const angle = Math.atan2(v1Y, v1X);

              const semiMajor = Math.sqrt(lambda1);
              const semiMinor = Math.sqrt(lambda2);

              const defs = svg.select('defs').empty() ? svg.append('defs') : svg.select('defs');
              const clipId = `sde-clip-${Date.now()}`;
              const clipPath = defs.append('clipPath').attr('id', clipId);
              clipPath
                .append('ellipse')
                .attr('cx', meanX)
                .attr('cy', meanY)
                .attr('rx', semiMajor)
                .attr('ry', semiMinor)
                .attr('transform', `rotate(${(angle * 180) / Math.PI} ${meanX} ${meanY})`);

              sdeGroup = svg.append('g').attr('class', 'sde-ellipse');
              if (sdeGroup) {
                sdeGroup.style('display', showSDE.value ? 'block' : 'none');
              }

              const clipGroup = sdeGroup.append('g').attr('clip-path', `url(#${clipId})`);
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', colors.backgroundGray);
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#topLeftGradient)')
                .attr('mix-blend-mode', 'screen');
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#topRightGradient)')
                .attr('mix-blend-mode', 'screen');
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#bottomLeftGradient)')
                .attr('mix-blend-mode', 'screen');
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#bottomRightGradient)')
                .attr('mix-blend-mode', 'screen');
            }
          }

          directionGridGroup = svg
            .append('g')
            .attr('class', 'direction-grid-lines')
            .style('pointer-events', 'none')
            .style('display', showDirectionGrid.value ? 'block' : 'none');

          const drawDirectionGrid = async () => {
            if (!directionGridGroup) return;

            const samplerWidth = Math.max(1, Math.round(gradientAreaWidth));
            const samplerHeight = Math.max(1, Math.round(gradientAreaHeight));
            let sampler = null;

            try {
              sampler = await createGradientSampler(samplerWidth, samplerHeight);
            } catch (err) {
              sampler = null;
            }

            if (!isMounted.value || currentDrawVersion !== drawVersion || !directionGridGroup) {
              return;
            }

            directionGridGroup.selectAll('*').remove();

            const medianXPercent = medianCenter.value.x;
            const medianYPercent = medianCenter.value.y;

            const medianX = gradientAreaLeft + (medianXPercent / 100) * gradientAreaWidth;
            const medianY = gradientAreaTop + (medianYPercent / 100) * gradientAreaHeight;

            const medianCol = Math.floor((medianX - gradientAreaLeft) / cellWidth);
            const medianRow = Math.floor((medianY - gradientAreaTop) / cellHeight);
            const medianColClamped = Math.max(0, Math.min(medianCol, gridColumns - 1));
            const medianRowClamped = Math.max(0, Math.min(medianRow, gridRows - 1));

            const medianCellCenterX = gradientAreaLeft + (medianColClamped + 0.5) * cellWidth;
            const medianCellCenterY = gradientAreaTop + (medianRowClamped + 0.5) * cellHeight;

            let maxPointCountForDirection = 0;
            cellPointCounts.forEach((count) => {
              if (count > maxPointCountForDirection) {
                maxPointCountForDirection = count;
              }
            });

            const directionAngles = [];

            for (let row = 0; row < gridRows; row++) {
              for (let col = 0; col < gridColumns; col++) {
                const cellKey = `${col},${row}`;
                const pointCount = cellPointCounts.get(cellKey) || 0;

                if (pointCount === 0) {
                  continue;
                }

                const cellCenterX = gradientAreaLeft + (col + 0.5) * cellWidth;
                const cellCenterY = gradientAreaTop + (row + 0.5) * cellHeight;

                const centerXPercent = (cellCenterX - gradientAreaLeft) / gradientAreaWidth;
                const centerYPercent = (cellCenterY - gradientAreaTop) / gradientAreaHeight;

                const lineColor = sampler
                  ? sampler(
                      centerXPercent * (samplerWidth - 1),
                      centerYPercent * (samplerHeight - 1)
                    )
                  : getInterpolatedColorAtPosition(centerXPercent, centerYPercent);

                const minStrokeWidth = 2;
                const maxStrokeWidth = 16;
                let strokeWidth = minStrokeWidth;
                if (maxPointCountForDirection > 0) {
                  const ratio = pointCount / maxPointCountForDirection;
                  strokeWidth = minStrokeWidth + (maxStrokeWidth - minStrokeWidth) * ratio;
                }

                const dx = medianCellCenterX - cellCenterX;
                const dy = medianCellCenterY - cellCenterY;
                const distance = Math.sqrt(dx * dx + dy * dy);

                const lineLength = cellWidth * 0.8;

                if (distance > 0) {
                  const unitX = dx / distance;
                  const unitY = dy / distance;

                  const angle = Math.atan2(-dy, dx) * (180 / Math.PI);
                  const normalizedAngle = angle < 0 ? angle + 360 : angle;
                  directionAngles.push(normalizedAngle);

                  const halfLength = lineLength / 2;
                  const lineStartX = cellCenterX - unitX * halfLength;
                  const lineStartY = cellCenterY - unitY * halfLength;
                  const lineEndX = cellCenterX + unitX * halfLength;
                  const lineEndY = cellCenterY + unitY * halfLength;

                  directionGridGroup
                    .append('line')
                    .attr('x1', lineStartX)
                    .attr('y1', lineStartY)
                    .attr('x2', lineEndX)
                    .attr('y2', lineEndY)
                    .attr('stroke', lineColor)
                    .attr('stroke-width', strokeWidth + 'pt');
                }
              }
            }

            averageDirection.value = directionAngles.length;

            const circleDiameter = Math.min(cellWidth, cellHeight) / 2;
            const medianCellCenterXPercent =
              (medianCellCenterX - gradientAreaLeft) / gradientAreaWidth;
            const medianCellCenterYPercent =
              (medianCellCenterY - gradientAreaTop) / gradientAreaHeight;

            const circleColor = sampler
              ? sampler(
                  medianCellCenterXPercent * (samplerWidth - 1),
                  medianCellCenterYPercent * (samplerHeight - 1)
                )
              : getInterpolatedColorAtPosition(medianCellCenterXPercent, medianCellCenterYPercent);

            directionGridGroup
              .append('circle')
              .attr('cx', medianCellCenterX)
              .attr('cy', medianCellCenterY)
              .attr('r', circleDiameter / 2)
              .attr('fill', 'none')
              .attr('stroke', circleColor)
              .attr('stroke-width', '4pt');
          };

          drawDirectionGrid();

          const scaledGridCols = 20;
          const scaledGridRows = 20;

          const tempCellWidth = gradientAreaWidth / scaledGridCols;
          const tempCellHeight = gradientAreaHeight / scaledGridRows;

          const scaledCellPointCounts = new Map();
          if (points.length > 0) {
            points.forEach((point) => {
              let col = Math.floor((point.x - gradientAreaLeft) / tempCellWidth);
              let row = Math.floor((point.y - gradientAreaTop) / tempCellHeight);

              col = Math.max(0, Math.min(col, scaledGridCols - 1));
              row = Math.max(0, Math.min(row, scaledGridRows - 1));

              const cellKey = `${col},${row}`;
              scaledCellPointCounts.set(cellKey, (scaledCellPointCounts.get(cellKey) || 0) + 1);
            });
          }

          const rowMaxCounts = [];
          const colMaxCounts = [];

          for (let row = 0; row < scaledGridRows; row++) {
            let rowMax = 0;
            for (let col = 0; col < scaledGridCols; col++) {
              const cellKey = `${col},${row}`;
              const pointCount = scaledCellPointCounts.get(cellKey) || 0;
              if (pointCount > rowMax) {
                rowMax = pointCount;
              }
            }
            rowMaxCounts.push(rowMax);
          }

          for (let col = 0; col < scaledGridCols; col++) {
            let colMax = 0;
            for (let row = 0; row < scaledGridRows; row++) {
              const cellKey = `${col},${row}`;
              const pointCount = scaledCellPointCounts.get(cellKey) || 0;
              if (pointCount > colMax) {
                colMax = pointCount;
              }
            }
            colMaxCounts.push(colMax);
          }

          const colMaxCountsForCalc = colMaxCounts.map((max) => (max === 0 ? 1 : max));
          const colTotal = colMaxCountsForCalc.reduce((sum, max) => sum + max, 0);

          const scaledColWidths = colMaxCountsForCalc.map((max) => {
            const ratio = colTotal > 0 ? max / colTotal : 0;
            return ratio * gradientAreaWidth;
          });

          const rowMaxCountsForCalc = rowMaxCounts.map((max) => (max === 0 ? 1 : max));
          const rowTotal = rowMaxCountsForCalc.reduce((sum, max) => sum + max, 0);

          const scaledRowHeights = rowMaxCountsForCalc.map((max) => {
            const ratio = rowTotal > 0 ? max / rowTotal : 0;
            return ratio * gradientAreaHeight;
          });

          const colPositions = [0];
          for (let i = 0; i < scaledGridCols; i++) {
            colPositions.push(colPositions[i] + scaledColWidths[i]);
          }
          const actualColTotal = colPositions[scaledGridCols];
          if (Math.abs(actualColTotal - gradientAreaWidth) > 0.001) {
            const scale = gradientAreaWidth / actualColTotal;
            scaledColWidths.forEach((w, i) => {
              scaledColWidths[i] = w * scale;
            });
            colPositions.length = 1;
            for (let i = 0; i < scaledGridCols; i++) {
              colPositions.push(colPositions[i] + scaledColWidths[i]);
            }
            colPositions[scaledGridCols] = gradientAreaWidth;
          }

          const rowPositions = [0];
          for (let i = 0; i < scaledGridRows; i++) {
            rowPositions.push(rowPositions[i] + scaledRowHeights[i]);
          }
          const actualRowTotal = rowPositions[scaledGridRows];
          if (Math.abs(actualRowTotal - gradientAreaHeight) > 0.001) {
            const scale = gradientAreaHeight / actualRowTotal;
            scaledRowHeights.forEach((h, i) => {
              scaledRowHeights[i] = h * scale;
            });
            rowPositions.length = 1;
            for (let i = 0; i < scaledGridRows; i++) {
              rowPositions.push(rowPositions[i] + scaledRowHeights[i]);
            }
            rowPositions[scaledGridRows] = gradientAreaHeight;
          }

          scaledGridGroup = svg
            .append('g')
            .attr('class', 'scaled-grid-cells')
            .style('pointer-events', 'all')
            .style('display', showScaledGrid.value ? 'block' : 'none');

          const drawScaledGrid = async () => {
            if (!scaledGridGroup) return;

            scaledGridGroup.selectAll('*').remove();

            const samplerWidth = Math.max(1, Math.round(gradientAreaWidth));
            const samplerHeight = Math.max(1, Math.round(gradientAreaHeight));
            let sampler = null;

            try {
              sampler = await createGradientSampler(samplerWidth, samplerHeight);
            } catch (err) {
              sampler = null;
            }

            if (!isMounted.value || currentDrawVersion !== drawVersion || !scaledGridGroup) {
              return;
            }

            const svgDefs2 = svg.select('defs');
            const svgDefsElement2 = svgDefs2.empty() ? svg.append('defs') : svgDefs2;

            const scaledGridSizes = [];
            for (let row = 0; row < scaledGridRows; row++) {
              for (let col = 0; col < scaledGridCols; col++) {
                const x = gradientAreaLeft + colPositions[col];
                const y = gradientAreaTop + rowPositions[row];
                const cellWidth = colPositions[col + 1] - colPositions[col];
                const cellHeight = rowPositions[row + 1] - rowPositions[row];
                const cellKey = `${col},${row}`;
                const pointCount = scaledCellPointCounts.get(cellKey) || 0;

                if (pointCount === 0) {
                  continue;
                }

                const gridSize = cellWidth * cellHeight;
                scaledGridSizes.push(gridSize);

                const originalCenterX = gradientAreaLeft + (col + 0.5) * tempCellWidth;
                const originalCenterY = gradientAreaTop + (row + 0.5) * tempCellHeight;

                const centerXPercent = (originalCenterX - gradientAreaLeft) / gradientAreaWidth;
                const centerYPercent = (originalCenterY - gradientAreaTop) / gradientAreaHeight;

                const cellColor = sampler
                  ? sampler(
                      centerXPercent * (samplerWidth - 1),
                      centerYPercent * (samplerHeight - 1)
                    )
                  : getInterpolatedColorAtPosition(centerXPercent, centerYPercent);

                scaledGridGroup
                  .append('rect')
                  .attr('x', x)
                  .attr('y', y)
                  .attr('width', cellWidth)
                  .attr('height', cellHeight)
                  .attr('fill', cellColor)
                  .attr('stroke', 'none');

                const gradientIdVertical = `scaled-grid-vertical-${col}-${row}`;
                const gradientVertical = svgDefsElement2
                  .append('linearGradient')
                  .attr('id', gradientIdVertical)
                  .attr('gradientUnits', 'userSpaceOnUse')
                  .attr('x1', x)
                  .attr('y1', y)
                  .attr('x2', x)
                  .attr('y2', y + cellHeight);
                gradientVertical
                  .append('stop')
                  .attr('offset', '0%')
                  .attr('stop-color', '#f2f2f2')
                  .attr('stop-opacity', '0.25');
                gradientVertical
                  .append('stop')
                  .attr('offset', '100%')
                  .attr('stop-color', '#f2f2f2')
                  .attr('stop-opacity', '0');

                scaledGridGroup
                  .append('rect')
                  .attr('x', x)
                  .attr('y', y)
                  .attr('width', cellWidth)
                  .attr('height', cellHeight)
                  .attr('fill', `url(#${gradientIdVertical})`)
                  .attr('stroke', 'none');

                const gradientIdHorizontal = `scaled-grid-horizontal-${col}-${row}`;
                const gradientHorizontal = svgDefsElement2
                  .append('linearGradient')
                  .attr('id', gradientIdHorizontal)
                  .attr('gradientUnits', 'userSpaceOnUse')
                  .attr('x1', x + cellWidth)
                  .attr('y1', y)
                  .attr('x2', x)
                  .attr('y2', y);
                gradientHorizontal
                  .append('stop')
                  .attr('offset', '0%')
                  .attr('stop-color', '#f2f2f2')
                  .attr('stop-opacity', '0.25');
                gradientHorizontal
                  .append('stop')
                  .attr('offset', '100%')
                  .attr('stop-color', '#f2f2f2')
                  .attr('stop-opacity', '0');

                scaledGridGroup
                  .append('rect')
                  .attr('x', x)
                  .attr('y', y)
                  .attr('width', cellWidth)
                  .attr('height', cellHeight)
                  .attr('fill', `url(#${gradientIdHorizontal})`)
                  .attr('stroke', 'none');
              }
            }

            averageScaledGridSize.value = scaledGridSizes.length;
          };

          drawScaledGrid();

          const pointsArray = points.map((p) => [p.x, p.y]);
          const delaunay = Delaunay.from(pointsArray);
          const triangles = delaunay.triangles;

          const STANDARD_CANVAS_SIZE = 1080;

          const triangleAreas = [];
          const edgeLengths = [];
          const triangleData = [];
          for (let i = 0; i < triangles.length; i += 3) {
            const i0 = triangles[i];
            const i1 = triangles[i + 1];
            const i2 = triangles[i + 2];

            const x0 = pointsArray[i0][0];
            const y0 = pointsArray[i0][1];
            const x1 = pointsArray[i1][0];
            const y1 = pointsArray[i1][1];
            const x2 = pointsArray[i2][0];
            const y2 = pointsArray[i2][1];

            const normalizedX0 =
              ((x0 - gradientAreaLeft) / gradientAreaWidth) * STANDARD_CANVAS_SIZE;
            const normalizedY0 =
              ((y0 - gradientAreaTop) / gradientAreaHeight) * STANDARD_CANVAS_SIZE;
            const normalizedX1 =
              ((x1 - gradientAreaLeft) / gradientAreaWidth) * STANDARD_CANVAS_SIZE;
            const normalizedY1 =
              ((y1 - gradientAreaTop) / gradientAreaHeight) * STANDARD_CANVAS_SIZE;
            const normalizedX2 =
              ((x2 - gradientAreaLeft) / gradientAreaWidth) * STANDARD_CANVAS_SIZE;
            const normalizedY2 =
              ((y2 - gradientAreaTop) / gradientAreaHeight) * STANDARD_CANVAS_SIZE;

            const area =
              Math.abs(
                (normalizedX1 - normalizedX0) * (normalizedY2 - normalizedY0) -
                  (normalizedX2 - normalizedX0) * (normalizedY1 - normalizedY0)
              ) / 2;

            const edge1 = Math.sqrt((x1 - x0) ** 2 + (y1 - y0) ** 2);
            const edge2 = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
            const edge3 = Math.sqrt((x0 - x2) ** 2 + (y0 - y2) ** 2);

            const maxEdge = Math.max(edge1, edge2, edge3);

            triangleAreas.push(area);
            edgeLengths.push(maxEdge);
            triangleData.push({ x0, y0, x1, y1, x2, y2, area, maxEdge, i0, i1, i2 });
          }

          // 三角形個數 = triangles 陣列長度 / 3（每 3 個元素代表一個三角形）
          averageTriangleArea.value = triangles.length / 3;

          let medianArea = 0;
          if (triangleAreas.length > 0) {
            const sortedAreas = [...triangleAreas].sort((a, b) => a - b);
            const mid = Math.floor(sortedAreas.length / 2);
            medianArea =
              sortedAreas.length % 2 === 0
                ? (sortedAreas[mid - 1] + sortedAreas[mid]) / 2
                : sortedAreas[mid];
          }
          medianTriangleArea.value = medianArea;

          if (points.length >= 2) {
            const nearestNeighborDistances = [];
            for (let i = 0; i < points.length; i++) {
              let minDist = Infinity;
              for (let j = 0; j < points.length; j++) {
                if (i !== j) {
                  const dx = points[i].x - points[j].x;
                  const dy = points[i].y - points[j].y;
                  const dist = Math.sqrt(dx * dx + dy * dy);
                  if (dist < minDist) {
                    minDist = dist;
                  }
                }
              }
              if (minDist !== Infinity) {
                nearestNeighborDistances.push(minDist);
              }
            }

            const avgObservedDistance =
              nearestNeighborDistances.length > 0
                ? nearestNeighborDistances.reduce((sum, dist) => sum + dist, 0) /
                  nearestNeighborDistances.length
                : 0;

            const area = gradientAreaWidth * gradientAreaHeight;
            const density = points.length / area;
            const expectedDistance = density > 0 ? 1 / (2 * Math.sqrt(density)) : 0;

            const nnr = expectedDistance > 0 ? avgObservedDistance / expectedDistance : 0;
            nearestNeighborRatio.value = nnr;
          } else {
            nearestNeighborRatio.value = 0;
          }

          if (triangleData.length > 0) {
            delaunayFillGroup = svg.append('g').attr('class', 'delaunay-fill');
            if (delaunayFillGroup) {
              delaunayFillGroup.style('display', showDelaunayFill.value ? 'block' : 'none');
            }

            const defs = svg.select('defs').empty() ? svg.append('defs') : svg.select('defs');

            const minArea = Math.min(...triangleAreas);
            const maxArea = Math.max(...triangleAreas);

            const opacityScale =
              minArea < maxArea
                ? d3.scaleLinear().domain([minArea, maxArea]).range([0, 0.9])
                : d3.scaleLinear().domain([minArea, minArea]).range([0, 0.9]);

            triangleData.forEach((triangle, index) => {
              const clipId = `triangle-clip-${index}-${Date.now()}`;
              const clipPath = defs.append('clipPath').attr('id', clipId);
              clipPath
                .append('polygon')
                .attr(
                  'points',
                  `${triangle.x0},${triangle.y0} ${triangle.x1},${triangle.y1} ${triangle.x2},${triangle.y2}`
                );

              const clipGroup = delaunayFillGroup.append('g').attr('clip-path', `url(#${clipId})`);
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', colors.backgroundGray);
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#topLeftGradient)')
                .attr('mix-blend-mode', 'screen');
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#topRightGradient)')
                .attr('mix-blend-mode', 'screen');
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#bottomLeftGradient)')
                .attr('mix-blend-mode', 'screen');
              clipGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('fill', 'url(#bottomRightGradient)')
                .attr('mix-blend-mode', 'screen');
            });

            triangleData.forEach((triangle) => {
              const opacity = opacityScale(triangle.area);
              delaunayFillGroup
                .append('polygon')
                .attr(
                  'points',
                  `${triangle.x0},${triangle.y0} ${triangle.x1},${triangle.y1} ${triangle.x2},${triangle.y2}`
                )
                .attr('fill', colors.white || '#ffffff')
                .attr('fill-opacity', opacity)
                .attr('stroke', 'none');
            });
          }

          circleGridGroup = svg
            .append('g')
            .attr('class', 'circle-grid-cells')
            .style('pointer-events', 'all')
            .style('display', showCircleGrid.value ? 'block' : 'none');

          const circleGridColumns = 10;
          const circleGridRows = 10;
          const circleGridCellWidth = gradientAreaWidth / circleGridColumns;
          const circleGridCellHeight = gradientAreaHeight / circleGridRows;

          const circleGridCellPointCounts = new Map();
          if (allDataPoints.value.length > 0) {
            allDataPoints.value.forEach((item) => {
              const xPercent = parseFloat(item.x);
              const yPercent = parseFloat(item.y);

              const x = gradientAreaLeft + (xPercent / 100) * gradientAreaWidth;
              const y = gradientAreaTop + (yPercent / 100) * gradientAreaHeight;

              let col = Math.floor((x - gradientAreaLeft) / circleGridCellWidth);
              let row = Math.floor((y - gradientAreaTop) / circleGridCellHeight);

              col = Math.max(0, Math.min(col, circleGridColumns - 1));
              row = Math.max(0, Math.min(row, circleGridRows - 1));

              const cellKey = `${col},${row}`;
              circleGridCellPointCounts.set(
                cellKey,
                (circleGridCellPointCounts.get(cellKey) || 0) + 1
              );
            });
          }

          let circleGridMaxCount = 0;
          circleGridCellPointCounts.forEach((count) => {
            if (count > circleGridMaxCount) {
              circleGridMaxCount = count;
            }
          });
          let circleGridMinCount = circleGridMaxCount;
          circleGridCellPointCounts.forEach((count) => {
            if (count > 0 && count < circleGridMinCount) {
              circleGridMinCount = count;
            }
          });
          if (circleGridMaxCount === 0) {
            circleGridMinCount = 0;
          }

          const drawCircleGrid = async () => {
            if (!circleGridGroup) return;

            if (!isMounted.value || currentDrawVersion !== drawVersion || !circleGridGroup) {
              return;
            }

            circleGridGroup.selectAll('*').remove();

            const svgDefs = svg.select('defs');
            const svgDefsElement = svgDefs.empty() ? svg.append('defs') : svgDefs;

            const clipId = `circle-grid-clip-${Date.now()}`;
            const clipPath = svgDefsElement.append('clipPath').attr('id', clipId);

            const circles = [];
            const circleSizes = [];
            for (let row = 0; row < circleGridRows; row++) {
              for (let col = 0; col < circleGridColumns; col++) {
                const cellKey = `${col},${row}`;
                const pointCount = circleGridCellPointCounts.get(cellKey) || 0;

                if (pointCount === 0) {
                  continue;
                }

                const cellCenterX = gradientAreaLeft + (col + 0.5) * circleGridCellWidth;
                const cellCenterY = gradientAreaTop + (row + 0.5) * circleGridCellHeight;

                const maxDiameter = Math.min(circleGridCellWidth, circleGridCellHeight);
                const minDiameter = 8;
                let diameter;
                if (circleGridMaxCount === circleGridMinCount || circleGridMaxCount === 0) {
                  diameter = maxDiameter;
                } else {
                  const ratio =
                    (pointCount - circleGridMinCount) / (circleGridMaxCount - circleGridMinCount);
                  diameter = minDiameter + ratio * (maxDiameter - minDiameter);
                }
                diameter = diameter * 2;

                circles.push({
                  cx: cellCenterX,
                  cy: cellCenterY,
                  r: diameter / 2,
                  pointCount,
                });

                const radius = diameter / 2;
                const area = Math.PI * radius * radius;
                circleSizes.push(area);

                clipPath
                  .append('circle')
                  .attr('cx', cellCenterX)
                  .attr('cy', cellCenterY)
                  .attr('r', diameter / 2);
              }
            }

            averageCircleSize.value = circles.length;

            if (circles.length > 0) {
              const topLeftColor = colors.blue || 'hsl(210, 85%, 65%)';
              const topRightColor = colors.red || 'hsl(0, 85%, 65%)';
              const bottomLeftColor = colors.green || 'hsl(150, 85%, 65%)';
              const bottomRightColor = colors.white || 'hsl(210, 60%, 92%)';
              const backgroundGray = colors.backgroundGray || '#dedede';

              circleGridGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('clip-path', `url(#${clipId})`)
                .attr('fill', backgroundGray)
                .attr('stroke', 'none');

              const topLeftGradId = `circle-topLeft-${Date.now()}`;
              const topLeftGrad = svgDefsElement
                .append('radialGradient')
                .attr('id', topLeftGradId)
                .attr('gradientUnits', 'userSpaceOnUse')
                .attr('cx', gradientAreaLeft)
                .attr('cy', gradientAreaTop)
                .attr('r', Math.max(gradientAreaWidth, gradientAreaHeight) * 2.5);
              topLeftGrad
                .append('stop')
                .attr('offset', '0%')
                .attr('stop-color', topLeftColor)
                .attr('stop-opacity', '1');
              topLeftGrad
                .append('stop')
                .attr('offset', '92%')
                .attr('stop-color', topLeftColor)
                .attr('stop-opacity', '0');

              const topRightGradId = `circle-topRight-${Date.now()}`;
              const topRightGrad = svgDefsElement
                .append('radialGradient')
                .attr('id', topRightGradId)
                .attr('gradientUnits', 'userSpaceOnUse')
                .attr('cx', gradientAreaLeft + gradientAreaWidth)
                .attr('cy', gradientAreaTop)
                .attr('r', Math.max(gradientAreaWidth, gradientAreaHeight) * 1.3);
              topRightGrad
                .append('stop')
                .attr('offset', '0%')
                .attr('stop-color', topRightColor)
                .attr('stop-opacity', '1');
              topRightGrad
                .append('stop')
                .attr('offset', '60%')
                .attr('stop-color', topRightColor)
                .attr('stop-opacity', '0');

              const bottomLeftGradId = `circle-bottomLeft-${Date.now()}`;
              const bottomLeftGrad = svgDefsElement
                .append('radialGradient')
                .attr('id', bottomLeftGradId)
                .attr('gradientUnits', 'userSpaceOnUse')
                .attr('cx', gradientAreaLeft)
                .attr('cy', gradientAreaTop + gradientAreaHeight)
                .attr('r', Math.max(gradientAreaWidth, gradientAreaHeight) * 1.5);
              bottomLeftGrad
                .append('stop')
                .attr('offset', '0%')
                .attr('stop-color', bottomLeftColor)
                .attr('stop-opacity', '1');
              bottomLeftGrad
                .append('stop')
                .attr('offset', '70%')
                .attr('stop-color', bottomLeftColor)
                .attr('stop-opacity', '0');

              const bottomRightGradId = `circle-bottomRight-${Date.now()}`;
              const bottomRightGrad = svgDefsElement
                .append('radialGradient')
                .attr('id', bottomRightGradId)
                .attr('gradientUnits', 'userSpaceOnUse')
                .attr('cx', gradientAreaLeft + gradientAreaWidth)
                .attr('cy', gradientAreaTop + gradientAreaHeight)
                .attr('r', Math.max(gradientAreaWidth, gradientAreaHeight) * 1.5);
              bottomRightGrad
                .append('stop')
                .attr('offset', '0%')
                .attr('stop-color', bottomRightColor)
                .attr('stop-opacity', '1');
              bottomRightGrad
                .append('stop')
                .attr('offset', '70%')
                .attr('stop-color', bottomRightColor)
                .attr('stop-opacity', '0');

              circleGridGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('clip-path', `url(#${clipId})`)
                .attr('fill', `url(#${topLeftGradId})`)
                .attr('mix-blend-mode', 'screen')
                .attr('stroke', 'none');

              circleGridGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('clip-path', `url(#${clipId})`)
                .attr('fill', `url(#${topRightGradId})`)
                .attr('mix-blend-mode', 'screen')
                .attr('stroke', 'none');

              circleGridGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('clip-path', `url(#${clipId})`)
                .attr('fill', `url(#${bottomLeftGradId})`)
                .attr('mix-blend-mode', 'screen')
                .attr('stroke', 'none');

              const bottomRightRect = circleGridGroup
                .append('rect')
                .attr('x', gradientAreaLeft)
                .attr('y', gradientAreaTop)
                .attr('width', gradientAreaWidth)
                .attr('height', gradientAreaHeight)
                .attr('clip-path', `url(#${clipId})`)
                .attr('fill', `url(#${bottomRightGradId})`)
                .attr('mix-blend-mode', 'screen')
                .attr('stroke', 'none');

              bottomRightRect
                .on('mouseover', function (event) {
                  if (tooltip.value) {
                    const tooltipElement = tooltip.value;
                    tooltipElement.textContent = `${circles.length} 個圓`;
                    tooltipElement.style.opacity = '1';
                    tooltipElement.style.left = `${event.pageX + 10}px`;
                    tooltipElement.style.top = `${event.pageY + 10}px`;
                  }
                })
                .on('mouseout', function () {
                  if (tooltip.value) {
                    tooltip.value.style.opacity = '0';
                  }
                });
            }
          };

          drawCircleGrid();

          quadtreeGroup = svg
            .append('g')
            .attr('class', 'quadtree-cells')
            .style('pointer-events', 'all')
            .style('display', showQuadtree.value ? 'block' : 'none');

          const quadtreeLeft = gradientAreaLeft;
          const quadtreeTop = gradientAreaTop;
          const quadtreeRight = gradientAreaLeft + gradientAreaWidth;
          const quadtreeBottom = gradientAreaTop + gradientAreaHeight;

          const quadtreeDefs = svg.select('defs').empty() ? svg.append('defs') : svg.select('defs');
          const quadtreeClipId = `quadtree-clip-${Date.now()}`;
          const quadtreeClip = quadtreeDefs.append('clipPath').attr('id', quadtreeClipId);
          quadtreeClip
            .append('rect')
            .attr('x', gradientAreaLeft)
            .attr('y', gradientAreaTop)
            .attr('width', gradientAreaWidth)
            .attr('height', gradientAreaHeight);
          quadtreeGroup.attr('clip-path', `url(#${quadtreeClipId})`);

          const cellLevels = [];
          const collectCellLevels = (x0, y0, x1, y1, cellPoints, level = 0) => {
            const width = x1 - x0;
            const height = y1 - y0;

            if (cellPoints.length <= 1 || width <= 1 || height <= 1) {
              cellLevels.push(level);
              return;
            }

            const midX = x0 + width / 2;
            const midY = y0 + height / 2;

            const topLeft = cellPoints.filter(
              (p) => p.x >= x0 && p.x < midX && p.y >= y0 && p.y < midY
            );
            const topRight = cellPoints.filter(
              (p) => p.x >= midX && p.x < x1 && p.y >= y0 && p.y < midY
            );
            const bottomLeft = cellPoints.filter(
              (p) => p.x >= x0 && p.x < midX && p.y >= midY && p.y < y1
            );
            const bottomRight = cellPoints.filter(
              (p) => p.x >= midX && p.x < x1 && p.y >= midY && p.y < y1
            );

            collectCellLevels(x0, y0, midX, midY, topLeft, level + 1);
            collectCellLevels(midX, y0, x1, midY, topRight, level + 1);
            collectCellLevels(x0, midY, midX, y1, bottomLeft, level + 1);
            collectCellLevels(midX, midY, x1, y1, bottomRight, level + 1);
          };

          const pointsInRoot = points.filter(
            (p) =>
              p.x >= quadtreeLeft &&
              p.x < quadtreeRight &&
              p.y >= quadtreeTop &&
              p.y < quadtreeBottom
          );
          collectCellLevels(
            quadtreeLeft,
            quadtreeTop,
            quadtreeRight,
            quadtreeBottom,
            pointsInRoot,
            0
          );

          const minLevel = cellLevels.length > 0 ? Math.min(...cellLevels) : 0;
          const maxLevel = cellLevels.length > 0 ? Math.max(...cellLevels) : 0;

          const opacityScale =
            minLevel < maxLevel
              ? d3.scaleLinear().domain([minLevel, maxLevel]).range([0.5, 1.0])
              : d3.scaleLinear().domain([minLevel, minLevel]).range([0.5, 0.5]);

          const drawQuadtree = async () => {
            if (!quadtreeGroup) return;

            const samplerWidth = Math.max(1, Math.round(gradientAreaWidth));
            const samplerHeight = Math.max(1, Math.round(gradientAreaHeight));
            let sampler = null;

            try {
              sampler = await createGradientSampler(samplerWidth, samplerHeight);
            } catch (err) {
              sampler = null;
            }

            if (!isMounted.value || currentDrawVersion !== drawVersion || !quadtreeGroup) {
              return;
            }

            const drawQuadtreeCell = (x0, y0, x1, y1, cellPoints, level = 0) => {
              const width = x1 - x0;
              const height = y1 - y0;

              if (cellPoints.length <= 1 || width <= 1 || height <= 1) {
                const opacity = cellPoints.length === 0 ? 0.25 : opacityScale(level);

                const cellCenterX = x0 + width / 2;
                const cellCenterY = y0 + height / 2;

                const centerXPercent = (cellCenterX - gradientAreaLeft) / gradientAreaWidth;
                const centerYPercent = (cellCenterY - gradientAreaTop) / gradientAreaHeight;

                const cellColor = sampler
                  ? sampler(
                      centerXPercent * (samplerWidth - 1),
                      centerYPercent * (samplerHeight - 1)
                    )
                  : getInterpolatedColorAtPosition(centerXPercent, centerYPercent);

                if (cellPoints.length > 0) {
                  const defs = svg.select('defs').empty() ? svg.append('defs') : svg.select('defs');
                  const clipId = `quadtree-corner-clip-${x0}-${y0}-${Date.now()}`;

                  const clipPath = defs.append('clipPath').attr('id', clipId);
                  clipPath
                    .append('rect')
                    .attr('x', x0)
                    .attr('y', y0)
                    .attr('width', width)
                    .attr('height', height);

                  const maskId = `quadtree-corner-mask-${x0}-${y0}-${Date.now()}`;
                  const mask = defs.append('mask').attr('id', maskId);
                  mask
                    .append('rect')
                    .attr('x', x0)
                    .attr('y', y0)
                    .attr('width', width)
                    .attr('height', height)
                    .attr('fill', 'white');
                  mask
                    .append('ellipse')
                    .attr('cx', cellCenterX)
                    .attr('cy', cellCenterY)
                    .attr('rx', width / 2)
                    .attr('ry', height / 2)
                    .attr('fill', 'black');

                  quadtreeGroup
                    .append('rect')
                    .attr('x', x0)
                    .attr('y', y0)
                    .attr('width', width)
                    .attr('height', height)
                    .attr('fill', colors.darkGray)
                    .attr('mask', `url(#${maskId})`)
                    .attr('stroke', 'none');

                  quadtreeGroup
                    .append('ellipse')
                    .attr('cx', cellCenterX)
                    .attr('cy', cellCenterY)
                    .attr('rx', width / 2)
                    .attr('ry', height / 2)
                    .attr('fill', cellColor)
                    .attr('fill-opacity', opacity)
                    .attr('stroke', colors.darkGray)
                    .attr('stroke-width', '0.5pt');
                } else {
                  quadtreeGroup
                    .append('rect')
                    .attr('x', x0)
                    .attr('y', y0)
                    .attr('width', width)
                    .attr('height', height)
                    .attr('fill', cellColor)
                    .attr('fill-opacity', opacity)
                    .attr('stroke', colors.darkGray)
                    .attr('stroke-width', '0.5pt');
                }
                return;
              }

              const midX = x0 + width / 2;
              const midY = y0 + height / 2;

              const topLeft = cellPoints.filter(
                (p) => p.x >= x0 && p.x < midX && p.y >= y0 && p.y < midY
              );
              const topRight = cellPoints.filter(
                (p) => p.x >= midX && p.x < x1 && p.y >= y0 && p.y < midY
              );
              const bottomLeft = cellPoints.filter(
                (p) => p.x >= x0 && p.x < midX && p.y >= midY && p.y < y1
              );
              const bottomRight = cellPoints.filter(
                (p) => p.x >= midX && p.x < x1 && p.y >= midY && p.y < y1
              );

              drawQuadtreeCell(x0, y0, midX, midY, topLeft, level + 1);
              drawQuadtreeCell(midX, y0, x1, midY, topRight, level + 1);
              drawQuadtreeCell(x0, midY, midX, y1, bottomLeft, level + 1);
              drawQuadtreeCell(midX, midY, x1, y1, bottomRight, level + 1);
            };

            drawQuadtreeCell(
              quadtreeLeft,
              quadtreeTop,
              quadtreeRight,
              quadtreeBottom,
              pointsInRoot,
              0
            );
          };

          drawQuadtree();

          straightGridGroup = svg
            .append('g')
            .attr('class', 'straight-grid-cells')
            .style('pointer-events', 'all')
            .style('display', showStraightGrid.value ? 'block' : 'none');

          if (points.length > 0) {
            let minX = points[0].x;
            let maxX = points[0].x;
            let minY = points[0].y;
            let maxY = points[0].y;

            points.forEach((point) => {
              if (point.x < minX) minX = point.x;
              if (point.x > maxX) maxX = point.x;
              if (point.y < minY) minY = point.y;
              if (point.y > maxY) maxY = point.y;
            });

            const boundaryWidth = maxX - minX;
            const boundaryHeight = maxY - minY;

            straightGridGroup
              .append('rect')
              .attr('x', minX)
              .attr('y', minY)
              .attr('width', boundaryWidth)
              .attr('height', boundaryHeight)
              .attr('fill', 'none')
              .attr('stroke', colors.darkGray || '#000000')
              .attr('stroke-width', '2px');

            const calculateMedian = (values) => {
              if (values.length === 0) return 0;
              const sorted = [...values].sort((a, b) => a - b);
              const middle = Math.floor(sorted.length / 2);
              if (sorted.length % 2 === 0) {
                return (sorted[middle - 1] + sorted[middle]) / 2;
              }
              return sorted[middle];
            };

            const midX = calculateMedian(points.map((p) => p.x));
            const midY = calculateMedian(points.map((p) => p.y));

            straightGridGroup
              .append('line')
              .attr('x1', minX)
              .attr('y1', midY)
              .attr('x2', maxX)
              .attr('y2', midY)
              .attr('stroke', colors.darkGray || '#000000')
              .attr('stroke-width', '2px');

            straightGridGroup
              .append('line')
              .attr('x1', midX)
              .attr('y1', minY)
              .attr('x2', midX)
              .attr('y2', maxY)
              .attr('stroke', colors.darkGray || '#000000')
              .attr('stroke-width', '2px');

            const grids = [
              {
                left: minX,
                top: minY,
                right: midX,
                bottom: midY,
              },
              {
                left: midX,
                top: minY,
                right: maxX,
                bottom: midY,
              },
              {
                left: minX,
                top: midY,
                right: midX,
                bottom: maxY,
              },
              {
                left: midX,
                top: midY,
                right: maxX,
                bottom: maxY,
              },
            ];

            const gridPointCounts = grids.map((grid) => {
              const pointsInGrid = points.filter((point) => {
                return (
                  point.x >= grid.left &&
                  point.x <= grid.right &&
                  point.y >= grid.top &&
                  point.y <= grid.bottom
                );
              });
              return {
                grid: grid,
                points: pointsInGrid,
                count: pointsInGrid.length,
              };
            });

            let maxCount = -1;
            let maxGridIndex = -1;
            gridPointCounts.forEach((item, index) => {
              if (item.count > maxCount) {
                maxCount = item.count;
                maxGridIndex = index;
              }
            });

            const totalMedianX = calculateMedian(points.map((p) => p.x));
            const totalMedianY = calculateMedian(points.map((p) => p.y));

            const redPoints = [];

            gridPointCounts.forEach((item, index) => {
              if (index === maxGridIndex) {
                return;
              }

              if (item.points.length > 0) {
                const medianX = calculateMedian(item.points.map((p) => p.x));
                const medianY = calculateMedian(item.points.map((p) => p.y));
                redPoints.push({ x: medianX, y: medianY });

                straightGridGroup
                  .append('circle')
                  .attr('cx', medianX)
                  .attr('cy', medianY)
                  .attr('r', 4)
                  .attr('fill', colors.red || '#E84A4A')
                  .attr('stroke', colors.darkGray || '#000000')
                  .attr('stroke-width', '1px');
              }
            });

            if (maxGridIndex >= 0 && gridPointCounts[maxGridIndex].count > 0) {
              const maxGrid = grids[maxGridIndex];
              const pointsInMaxGrid = gridPointCounts[maxGridIndex].points;
              const subMidX = calculateMedian(pointsInMaxGrid.map((p) => p.x));
              const subMidY = calculateMedian(pointsInMaxGrid.map((p) => p.y));

              straightGridGroup
                .append('line')
                .attr('x1', maxGrid.left)
                .attr('y1', subMidY)
                .attr('x2', maxGrid.right)
                .attr('y2', subMidY)
                .attr('stroke', colors.darkGray || '#000000')
                .attr('stroke-width', '2px');

              straightGridGroup
                .append('line')
                .attr('x1', subMidX)
                .attr('y1', maxGrid.top)
                .attr('x2', subMidX)
                .attr('y2', maxGrid.bottom)
                .attr('stroke', colors.darkGray || '#000000')
                .attr('stroke-width', '2px');

              const subGrids = [
                {
                  left: maxGrid.left,
                  top: maxGrid.top,
                  right: subMidX,
                  bottom: subMidY,
                },
                {
                  left: subMidX,
                  top: maxGrid.top,
                  right: maxGrid.right,
                  bottom: subMidY,
                },
                {
                  left: maxGrid.left,
                  top: subMidY,
                  right: subMidX,
                  bottom: maxGrid.bottom,
                },
                {
                  left: subMidX,
                  top: subMidY,
                  right: maxGrid.right,
                  bottom: maxGrid.bottom,
                },
              ];

              subGrids.forEach((subGrid) => {
                const pointsInSubGrid = gridPointCounts[maxGridIndex].points.filter((point) => {
                  return (
                    point.x >= subGrid.left &&
                    point.x <= subGrid.right &&
                    point.y >= subGrid.top &&
                    point.y <= subGrid.bottom
                  );
                });

                if (pointsInSubGrid.length > 0) {
                  const medianX = calculateMedian(pointsInSubGrid.map((p) => p.x));
                  const medianY = calculateMedian(pointsInSubGrid.map((p) => p.y));
                  redPoints.push({ x: medianX, y: medianY });

                  straightGridGroup
                    .append('circle')
                    .attr('cx', medianX)
                    .attr('cy', medianY)
                    .attr('r', 4)
                    .attr('fill', colors.red || '#E84A4A')
                    .attr('stroke', colors.darkGray || '#000000')
                    .attr('stroke-width', '1px');
                }
              });
            }

            if (redPoints.length > 0) {
              redPoints.forEach((redPoint) => {
                straightGridGroup
                  .append('line')
                  .attr('x1', totalMedianX)
                  .attr('y1', totalMedianY)
                  .attr('x2', redPoint.x)
                  .attr('y2', redPoint.y)
                  .attr('stroke', colors.red || '#E84A4A')
                  .attr('stroke-width', '1px');
              });
            }
          }

          const bottomLineGridCols = 20;
          const bottomLineGridRows = 20;
          const bottomLineCellWidth = gradientAreaWidth / bottomLineGridCols;
          const bottomLineCellHeight = gradientAreaHeight / bottomLineGridRows;

          const bottomLineCellPointCounts = new Map();
          if (points.length > 0) {
            points.forEach((point) => {
              let col = Math.floor((point.x - gradientAreaLeft) / bottomLineCellWidth);
              let row = Math.floor((point.y - gradientAreaTop) / bottomLineCellHeight);

              col = Math.max(0, Math.min(col, bottomLineGridCols - 1));
              row = Math.max(0, Math.min(row, bottomLineGridRows - 1));

              const cellKey = `${col},${row}`;
              bottomLineCellPointCounts.set(
                cellKey,
                (bottomLineCellPointCounts.get(cellKey) || 0) + 1
              );
            });
          }

          let maxPointCount = 0;
          bottomLineCellPointCounts.forEach((count) => {
            if (count > maxPointCount) {
              maxPointCount = count;
            }
          });

          lineChartGroup = svg
            .append('g')
            .attr('class', 'line-chart')
            .style('pointer-events', 'all')
            .style('display', showLineChart.value ? 'block' : 'none');

          const lineChartGridCols = bottomLineGridCols;
          const lineChartGridRows = bottomLineGridRows;
          const lineChartCellWidth = bottomLineCellWidth;
          const lineChartCellHeight = bottomLineCellHeight;

          for (let row = 0; row < lineChartGridRows; row++) {
            const points = [];
            for (let col = 0; col < lineChartGridCols; col++) {
              const cellKey = `${col},${row}`;
              const pointCount = bottomLineCellPointCounts.get(cellKey) || 0;

              const x = gradientAreaLeft + (col + 0.5) * lineChartCellWidth;
              const y = gradientAreaTop + row * lineChartCellHeight;

              let rectHeight;
              if (pointCount === 0) {
                rectHeight = 1;
              } else if (pointCount === 1) {
                rectHeight = 2;
              } else {
                const maxHeight = lineChartCellHeight;
                const minHeight = 2;
                if (maxPointCount > 1) {
                  const ratio = (pointCount - 1) / (maxPointCount - 1);
                  rectHeight = minHeight + ratio * (maxHeight - minHeight);
                } else {
                  rectHeight = minHeight;
                }
              }

              const pointY = y + lineChartCellHeight - rectHeight * 2;
              points.push([x, pointY]);
            }

            if (points.length > 0) {
              const lineGenerator = d3
                .line()
                .x((d) => d[0])
                .y((d) => d[1])
                .curve(d3.curveBumpX);

              lineChartGroup
                .append('path')
                .attr('d', lineGenerator(points))
                .attr('fill', 'none')
                .attr('stroke', colors.darkGray || '#333333')
                .attr('stroke-width', 1)
                .attr('opacity', 0.8);
            }
          }

          barChartGroup = svg
            .append('g')
            .attr('class', 'bar-chart-cells')
            .style('pointer-events', 'all')
            .style('display', showBarChart.value ? 'block' : 'none');

          const barChartGridCols = bottomLineGridCols;
          const barChartGridRows = bottomLineGridRows;
          const barChartCellWidth = bottomLineCellWidth;
          const barChartCellHeight = bottomLineCellHeight;

          const rowTotals = Array(barChartGridRows).fill(0);
          for (let row = 0; row < barChartGridRows; row++) {
            for (let col = 0; col < barChartGridCols; col++) {
              const cellKey = `${col},${row}`;
              rowTotals[row] += bottomLineCellPointCounts.get(cellKey) || 0;
            }
          }

          const colTotals = Array(barChartGridCols).fill(0);
          for (let col = 0; col < barChartGridCols; col++) {
            for (let row = 0; row < barChartGridRows; row++) {
              const cellKey = `${col},${row}`;
              colTotals[col] += bottomLineCellPointCounts.get(cellKey) || 0;
            }
          }

          const maxRowTotal = Math.max(...rowTotals, 1);
          const maxColTotal = Math.max(...colTotals, 1);

          let overallAvgX = 0;
          let overallAvgY = 0;
          if (points.length > 0) {
            points.forEach((point) => {
              overallAvgX += point.x;
              overallAvgY += point.y;
            });
            overallAvgX /= points.length;
            overallAvgY /= points.length;
          } else {
            overallAvgX = gradientAreaLeft + gradientAreaWidth / 2;
            overallAvgY = gradientAreaTop + gradientAreaHeight / 2;
          }

          const centerX = gradientAreaLeft + gradientAreaWidth / 2;
          const centerY = gradientAreaTop + gradientAreaHeight / 2;

          const isLeftBias = overallAvgX < centerX;
          const isTopBias = overallAvgY < centerY;

          const drawBarChart = async () => {
            if (!barChartGroup) return;

            const samplerWidth = Math.max(1, Math.round(gradientAreaWidth));
            const samplerHeight = Math.max(1, Math.round(gradientAreaHeight));
            let sampler = null;

            try {
              sampler = await createGradientSampler(samplerWidth, samplerHeight);
            } catch (err) {
              sampler = null;
            }

            if (!isMounted.value || currentDrawVersion !== drawVersion || !barChartGroup) {
              return;
            }

            for (let row = 0; row < barChartGridRows; row++) {
              const rowY = gradientAreaTop + row * barChartCellHeight;
              const ratio = maxRowTotal > 0 ? rowTotals[row] / maxRowTotal : 0;
              const barWidth = ratio * (gradientAreaWidth / 2);

              const barCenterY = rowY + barChartCellHeight / 2;

              let barX;
              let colorX, colorY;
              if (isLeftBias) {
                barX = gradientAreaLeft;
                colorX = gradientAreaLeft;
                colorY = barCenterY;
              } else {
                barX =
                  gradientAreaLeft +
                  (barChartGridCols - 1) * barChartCellWidth +
                  (barChartCellWidth - barWidth);
                colorX = gradientAreaLeft + gradientAreaWidth;
                colorY = barCenterY;
              }

              const colorXPercent = (colorX - gradientAreaLeft) / gradientAreaWidth;
              const colorYPercent = (colorY - gradientAreaTop) / gradientAreaHeight;

              const barColor = sampler
                ? sampler(colorXPercent * (samplerWidth - 1), colorYPercent * (samplerHeight - 1))
                : getInterpolatedColorAtPosition(colorXPercent, colorYPercent);

              barChartGroup
                .append('rect')
                .attr('x', barX)
                .attr('y', rowY)
                .attr('width', barWidth)
                .attr('height', barChartCellHeight)
                .attr('fill', barColor)
                .attr('fill-opacity', 0.5)
                .attr('stroke', 'none');
            }

            for (let col = 0; col < barChartGridCols; col++) {
              const colX = gradientAreaLeft + col * barChartCellWidth;
              const ratio = maxColTotal > 0 ? colTotals[col] / maxColTotal : 0;
              const barHeight = ratio * (gradientAreaHeight / 2);

              const barCenterX = colX + barChartCellWidth / 2;

              let barY;
              let colorX, colorY;
              if (isTopBias) {
                barY = gradientAreaTop;
                colorX = barCenterX;
                colorY = gradientAreaTop;
              } else {
                barY =
                  gradientAreaTop +
                  (barChartGridRows - 1) * barChartCellHeight +
                  (barChartCellHeight - barHeight);
                colorX = barCenterX;
                colorY = gradientAreaTop + gradientAreaHeight;
              }

              const colorXPercent = (colorX - gradientAreaLeft) / gradientAreaWidth;
              const colorYPercent = (colorY - gradientAreaTop) / gradientAreaHeight;

              const barColor = sampler
                ? sampler(colorXPercent * (samplerWidth - 1), colorYPercent * (samplerHeight - 1))
                : getInterpolatedColorAtPosition(colorXPercent, colorYPercent);

              barChartGroup
                .append('rect')
                .attr('x', colX)
                .attr('y', barY)
                .attr('width', barChartCellWidth)
                .attr('height', barHeight)
                .attr('fill', barColor)
                .attr('fill-opacity', 0.5)
                .attr('stroke', 'none');
            }
          };

          drawBarChart();
        }

        if (allDataPoints.value.length > 0) {
          const validPoints = [];
          allDataPoints.value.forEach((item) => {
            const x = parseFloat(item.x);
            const y = parseFloat(item.y);

            if (!isNaN(x) && !isNaN(y) && x >= 0 && y >= 0 && x <= 100 && y <= 100) {
              validPoints.push({ x, y });
            }
          });

          if (validPoints.length > 0) {
            let sumX = 0;
            let sumY = 0;
            validPoints.forEach((p) => {
              sumX += p.x;
              sumY += p.y;
            });
            const meanXPercent = sumX / validPoints.length;
            const meanYPercent = sumY / validPoints.length;
            meanCenter.value = { x: meanXPercent, y: meanYPercent };

            const sortedX = validPoints.map((p) => p.x).sort((a, b) => a - b);
            const sortedY = validPoints.map((p) => p.y).sort((a, b) => a - b);
            const medianXPercent =
              validPoints.length % 2 === 0
                ? (sortedX[validPoints.length / 2 - 1] + sortedX[validPoints.length / 2]) / 2
                : sortedX[Math.floor(validPoints.length / 2)];
            const medianYPercent =
              validPoints.length % 2 === 0
                ? (sortedY[validPoints.length / 2 - 1] + sortedY[validPoints.length / 2]) / 2
                : sortedY[Math.floor(validPoints.length / 2)];
            medianCenter.value = { x: medianXPercent, y: medianYPercent };

            let minTotalDistance = Infinity;
            let centralFeatureIndex = 0;
            validPoints.forEach((point, index) => {
              let totalDistance = 0;
              validPoints.forEach((otherPoint) => {
                const dx = point.x - otherPoint.x;
                const dy = point.y - otherPoint.y;
                totalDistance += Math.sqrt(dx * dx + dy * dy);
              });
              if (totalDistance < minTotalDistance) {
                minTotalDistance = totalDistance;
                centralFeatureIndex = index;
              }
            });
            const centralPoint = validPoints[centralFeatureIndex];
            centralFeature.value = { x: centralPoint.x, y: centralPoint.y };
          }
        }
      };

      const handleResize = () => {
        if (resizeTimer) {
          clearTimeout(resizeTimer);
        }
        resizeTimer = safeSetTimeout(() => {
          if (!isMounted.value) return;
          if (!loading.value && allDataPoints.value.length > 0) {
            drawVisualization();
          }
        }, 100);
      };

      const goHome = () => {
        router.push('/');
      };

      const downloadData = async () => {
        try {
          if (!allDataPoints.value || allDataPoints.value.length === 0) {
            alert('沒有資料可下載');
            return;
          }

          const jsonString = JSON.stringify(allDataPoints.value, null, 2);

          const blob = new Blob([jsonString], { type: 'application/json' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'data.json';
          link.click();
          URL.revokeObjectURL(url);

          alert(`已下載 ${allDataPoints.value.length} 筆資料`);
        } catch (err) {
          alert(`下載資料時發生錯誤: ${err.message}`);
        }
      };

      const downloadImage = () => {
        if (!svg || !contentContainer.value) return;

        const containerRect = contentContainer.value.getBoundingClientRect();
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;

        const firstSectionWidth = calculateSideSectionWidth(containerWidth);
        const rightWidth = calculateSideSectionWidth(containerWidth);
        const titleAreaHeight = 0;
        const gradientAreaWidth = containerWidth - firstSectionWidth - rightWidth;
        const gradientAreaHeight = containerHeight - titleAreaHeight;
        const gradientAreaLeft = firstSectionWidth;
        const gradientAreaTop = titleAreaHeight;

        const originalSvg = svg.node();
        if (!originalSvg) return;

        const viewBoxX = gradientAreaLeft;
        const viewBoxY = gradientAreaTop;
        const viewBoxWidth = gradientAreaWidth;
        const viewBoxHeight = gradientAreaHeight;

        const pngSize = 4320;

        const newSvg = originalSvg.cloneNode(true);
        newSvg.setAttribute('width', pngSize.toString());
        newSvg.setAttribute('height', pngSize.toString());
        newSvg.setAttribute('viewBox', `${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`);
        newSvg.setAttribute('preserveAspectRatio', 'none');

        const yellowRect = newSvg.querySelector('.dark-gray-layer rect');
        if (yellowRect) {
          yellowRect.setAttribute('fill', 'transparent');
        }

        const svgData = new XMLSerializer().serializeToString(newSvg);
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        const canvas = document.createElement('canvas');
        canvas.width = pngSize;
        canvas.height = pngSize;
        const ctx = canvas.getContext('2d');

        const img = new Image();
        img.onload = () => {
          ctx.drawImage(img, 0, 0, pngSize, pngSize);
          URL.revokeObjectURL(url);

          canvas.toBlob((blob) => {
            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `heatmap-${Date.now()}.png`;
            link.click();
            URL.revokeObjectURL(downloadUrl);
          }, 'image/png');
        };
        img.src = url;
      };

      const downloadPDF = async () => {
        if (!svg || !contentContainer.value) return;

        const containerRect = contentContainer.value.getBoundingClientRect();
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;

        const firstSectionWidth = calculateSideSectionWidth(containerWidth);
        const rightWidth = calculateSideSectionWidth(containerWidth);
        const titleAreaHeight = 0;
        const gradientAreaWidth = containerWidth - firstSectionWidth - rightWidth;
        const gradientAreaHeight = containerHeight - titleAreaHeight;
        const gradientAreaLeft = firstSectionWidth;
        const gradientAreaTop = titleAreaHeight;

        const originalSvg = svg.node();
        if (!originalSvg) return;

        const viewBoxX = gradientAreaLeft;
        const viewBoxY = gradientAreaTop;
        const viewBoxWidth = gradientAreaWidth;
        const viewBoxHeight = gradientAreaHeight;

        const pdfWidth = 1080;
        const pdfHeight = 1080;

        const newSvg = originalSvg.cloneNode(true);
        newSvg.setAttribute('width', pdfWidth.toString());
        newSvg.setAttribute('height', pdfHeight.toString());
        newSvg.setAttribute('viewBox', `${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`);
        newSvg.setAttribute('preserveAspectRatio', 'none');

        const yellowRect = newSvg.querySelector('.dark-gray-layer rect');
        if (yellowRect) {
          yellowRect.setAttribute('fill', 'transparent');
        }

        const gradientGroup = newSvg.querySelector('.gradient-spectrum');
        if (gradientGroup) {
          gradientGroup.remove();
        }

        const blendElements = newSvg.querySelectorAll(
          '[mix-blend-mode], [style*="mix-blend-mode"]'
        );
        blendElements.forEach((element) => {
          element.removeAttribute('mix-blend-mode');
          if (element.style && element.style.mixBlendMode) {
            element.style.mixBlendMode = '';
          }
          const style = element.getAttribute('style');
          if (style && style.includes('mix-blend-mode')) {
            element.setAttribute('style', style.replace(/mix-blend-mode:[^;]+;?/g, ''));
          }
        });

        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'pt',
          format: [pdfWidth, pdfHeight],
          compress: true,
        });

        try {
          await pdf.svg(newSvg, {
            x: 0,
            y: 0,
            width: pdfWidth,
            height: pdfHeight,
            loadExternalStyleSheets: true,
          });
          pdf.save(`heatmap-${Date.now()}.pdf`);
        } catch (error) {
          console.error('PDF 轉換失敗:', error);
          alert(`PDF 轉換失敗: ${error.message}`);
        }
      };

      const createToggleFunction = (showRef, getGroupRef, invertDisplay = false) => {
        return () => {
          showRef.value = !showRef.value;
          const groupRef = getGroupRef();
          if (groupRef) {
            const displayValue = invertDisplay
              ? showRef.value
                ? 'none'
                : 'block'
              : showRef.value
                ? 'block'
                : 'none';
            groupRef.style('display', displayValue);
          }
        };
      };

      const toggleDataPoints = createToggleFunction(showDataPoints, () => pointsGroup);
      const toggleCrosshairPoints = createToggleFunction(showCrosshairPoints, () => crosshairGroup);
      const toggleDelaunayFill = createToggleFunction(showDelaunayFill, () => delaunayFillGroup);
      const toggleSDE = createToggleFunction(showSDE, () => sdeGroup);
      const toggleColorGrid = createToggleFunction(showColorGrid, () => colorGridGroup);
      const toggleDirectionGrid = createToggleFunction(showDirectionGrid, () => directionGridGroup);
      const toggleCircleGrid = createToggleFunction(showCircleGrid, () => circleGridGroup);
      const toggleQuadtree = createToggleFunction(showQuadtree, () => quadtreeGroup);
      const toggleScaledGrid = createToggleFunction(showScaledGrid, () => scaledGridGroup);
      const toggleStraightGrid = createToggleFunction(showStraightGrid, () => straightGridGroup);
      const toggleBottomLineGrid = createToggleFunction(
        showBottomLineGrid,
        () => bottomLineGridGroup
      );
      const toggleBarChart = createToggleFunction(showBarChart, () => barChartGroup);
      const toggleLineChart = createToggleFunction(showLineChart, () => lineChartGroup);
      const toggleGradient = createToggleFunction(showGradient, () => gradientGroup);
      const toggleDarkGrayLayer = createToggleFunction(
        showDarkGrayLayer,
        () => darkGrayLayerGroup,
        true
      );

      const toggleDBSCAN = () => {
        showDBSCAN.value = !showDBSCAN.value;
      };

      onMounted(() => {
        isMounted.value = true;
        loadCookieData();

        if (POLITICIAN_NAMES.length > 0) {
          selectedName.value = POLITICIAN_NAMES[0];
          loading.value = true;
          loadData(selectedName.value);
        } else {
          loading.value = false;
        }
        window.addEventListener('resize', handleResize);
      });

      onBeforeUnmount(() => {
        isMounted.value = false;

        drawVersion += 1000;

        pendingTimeouts.forEach((timeoutId) => {
          clearTimeout(timeoutId);
        });
        pendingTimeouts.length = 0;

        if (resizeTimer) {
          clearTimeout(resizeTimer);
          resizeTimer = null;
        }

        colorGridGroup = null;
        directionGridGroup = null;
        circleGridGroup = null;
        quadtreeGroup = null;
        scaledGridGroup = null;
        straightGridGroup = null;
        barChartGroup = null;
        lineChartGroup = null;
        delaunayFillGroup = null;
        gradientGroup = null;
        darkGrayLayerGroup = null;
        pointsGroup = null;
        crosshairGroup = null;
        sdeGroup = null;
        svg = null;

        if (svgContainer.value) {
          try {
            d3.select(svgContainer.value).selectAll('svg').remove();
          } catch (e) {
            void e;
          }
        }
      });

      const meanCenterColor = computed(() => {
        if (!isMounted.value) return 'transparent';
        try {
          const c = meanCenter.value;
          if (!c || typeof c !== 'object') return 'transparent';
          const x = Number(c.x);
          const y = Number(c.y);
          if (isNaN(x) || isNaN(y) || (x === 0 && y === 0)) return 'transparent';
          return getInterpolatedColorAtPosition(x / 100, y / 100);
        } catch {
          return 'transparent';
        }
      });

      const medianCenterColor = computed(() => {
        if (!isMounted.value) return 'transparent';
        try {
          const c = medianCenter.value;
          if (!c || typeof c !== 'object') return 'transparent';
          const x = Number(c.x);
          const y = Number(c.y);
          if (isNaN(x) || isNaN(y) || (x === 0 && y === 0)) return 'transparent';
          return getInterpolatedColorAtPosition(x / 100, y / 100);
        } catch {
          return 'transparent';
        }
      });

      const centralFeatureColor = computed(() => {
        if (!isMounted.value) return 'transparent';
        try {
          const c = centralFeature.value;
          if (!c || typeof c !== 'object') return 'transparent';
          const x = Number(c.x);
          const y = Number(c.y);
          if (isNaN(x) || isNaN(y) || (x === 0 && y === 0)) return 'transparent';
          return getInterpolatedColorAtPosition(x / 100, y / 100);
        } catch {
          return 'transparent';
        }
      });

      const meanCenterHex = computed(() => {
        if (!isMounted.value) return '';
        try {
          const c = meanCenter.value;
          if (!c || typeof c !== 'object') return '';
          const x = Number(c.x);
          const y = Number(c.y);
          if (isNaN(x) || isNaN(y) || (x === 0 && y === 0)) return '';
          const col = getInterpolatedColorAtPosition(x / 100, y / 100);
          return col && col !== 'transparent' ? rgbToHex(col) : '';
        } catch {
          return '';
        }
      });

      const medianCenterHex = computed(() => {
        if (!isMounted.value) return '';
        try {
          const c = medianCenter.value;
          if (!c || typeof c !== 'object') return '';
          const x = Number(c.x);
          const y = Number(c.y);
          if (isNaN(x) || isNaN(y) || (x === 0 && y === 0)) return '';
          const col = getInterpolatedColorAtPosition(x / 100, y / 100);
          return col && col !== 'transparent' ? rgbToHex(col) : '';
        } catch {
          return '';
        }
      });

      const centralFeatureHex = computed(() => {
        if (!isMounted.value) return '';
        try {
          const c = centralFeature.value;
          if (!c || typeof c !== 'object') return '';
          const x = Number(c.x);
          const y = Number(c.y);
          if (isNaN(x) || isNaN(y) || (x === 0 && y === 0)) return '';
          const col = getInterpolatedColorAtPosition(x / 100, y / 100);
          return col && col !== 'transparent' ? rgbToHex(col) : '';
        } catch {
          return '';
        }
      });

      const meanCenterText = computed(() => {
        try {
          if (
            !isMounted.value ||
            !meanCenter.value ||
            typeof meanCenter.value.x !== 'number' ||
            typeof meanCenter.value.y !== 'number'
          ) {
            return '(0.00, 0.00)';
          }
          return `(${meanCenter.value.x.toFixed(2)}, ${meanCenter.value.y.toFixed(2)})`;
        } catch (e) {
          return '(0.00, 0.00)';
        }
      });

      const medianCenterText = computed(() => {
        try {
          if (
            !isMounted.value ||
            !medianCenter.value ||
            typeof medianCenter.value.x !== 'number' ||
            typeof medianCenter.value.y !== 'number'
          ) {
            return '(0.00, 0.00)';
          }
          return `(${medianCenter.value.x.toFixed(2)}, ${medianCenter.value.y.toFixed(2)})`;
        } catch (e) {
          return '(0.00, 0.00)';
        }
      });

      const centralFeatureText = computed(() => {
        try {
          if (
            !isMounted.value ||
            !centralFeature.value ||
            typeof centralFeature.value.x !== 'number' ||
            typeof centralFeature.value.y !== 'number'
          ) {
            return '(0.00, 0.00)';
          }
          return `(${centralFeature.value.x.toFixed(2)}, ${centralFeature.value.y.toFixed(2)})`;
        } catch (e) {
          return '(0.00, 0.00)';
        }
      });

      onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
      });

      return {
        mainContainer,
        contentContainer,
        svgContainer,
        boxesContainer,
        diamondContainer,
        leftSection,
        centerSection,
        rightSection,
        rightSectionWidth,
        tooltip,
        showColorGrid,
        showDirectionGrid,
        showCircleGrid,
        showQuadtree,
        showScaledGrid,
        showStraightGrid,
        showBottomLineGrid,
        showBarChart,
        showLineChart,
        showGradient,
        showDarkGrayLayer,
        showDarkGrid,
        showDataPoints,
        showCrosshairPoints,
        showDelaunayFill,
        showSDE,
        showDBSCAN,
        averageTriangleArea,
        medianTriangleArea,
        nearestNeighborRatio,
        averageScaledGridSize,
        averageCircleSize,
        averageColorGrid,
        averageDirection,
        meanCenter,
        medianCenter,
        centralFeature,
        meanCenterColor,
        medianCenterColor,
        centralFeatureColor,
        meanCenterHex,
        medianCenterHex,
        centralFeatureHex,
        meanCenterText,
        medianCenterText,
        centralFeatureText,
        loading,
        error,
        goHome,
        toggleColorGrid,
        toggleDirectionGrid,
        toggleCircleGrid,
        toggleQuadtree,
        toggleScaledGrid,
        toggleStraightGrid,
        toggleBottomLineGrid,
        toggleBarChart,
        toggleLineChart,
        toggleGradient,
        toggleDarkGrayLayer,
        toggleDataPoints,
        toggleCrosshairPoints,
        toggleDelaunayFill,
        toggleSDE,
        toggleDBSCAN,
        downloadData,
        downloadImage,
        downloadPDF,
        POLITICIAN_NAMES,
        selectedName,
        handleNameClick,
        allDataPoints,
        totalDataPoints,
      };
    },
  };
</script>

<style>
  @import '../assets/css/common.css';
</style>
